import {isNavigateButton} from 'js/shared/keyCodes';

// Based on those values, some element styles was written.
// Be careful to update them.
const attributeKey = 'data-navigation';
const attrKeyboardValue = 'keyboard';
const attrMouseValue = 'mouse';
const updateStatus = function (isKeyboard = false) {
  const navigationType = isKeyboard ? attrKeyboardValue : attrMouseValue;
  window.document.body.setAttribute(attributeKey, navigationType)
}

const checkKeyboardNavigation = function (e) {
  if (isNavigateButton(e.keyCode)) {
    updateStatus(true)
  }
}

const checkClickNavigation = function () {
  updateStatus(false);
}

export default function () {
  const isAlreadyInited = window.document.body.getAttribute(attributeKey);
  if (isAlreadyInited) {
    return;
  }

  window.addEventListener('keyup', checkKeyboardNavigation)
  window.document.body.addEventListener('click', checkClickNavigation, true)
  updateStatus();
}
